import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";
import {
  PackChatConversationSkeleton,
  PackChatListSkeleton,
  PackChatPackSkeleton,
} from "@/payroll/pack-chat/pack-chat-skeletons";
import { PANE_COLUMNS } from "./pane-columns";

export const PackChatPanelSkeleton = () => (
  <Stack
    gap={0}
    align="stretch"
    className={cn(
      "grid min-w-0 md:h-full",
      PANE_COLUMNS.conversation,
      "animate-in duration-200 fade-in",
    )}
  >
    <Stack
      gap={0}
      align="stretch"
      className="min-h-0 min-w-0 md:h-full md:border-r md:border-line"
    >
      <PackChatListSkeleton />
    </Stack>
    <Stack
      gap={0}
      align="stretch"
      className="hidden min-h-0 min-w-0 md:block md:h-full"
    >
      <PackChatConversationSkeleton />
    </Stack>
    <Stack
      gap={0}
      align="stretch"
      className="hidden min-h-0 min-w-0 border-l border-line lg:block lg:h-full"
    >
      <PackChatPackSkeleton />
    </Stack>
  </Stack>
);
